/* eslint-disable import/prefer-default-export, react/prop-types */

import React from 'react';
import MuiWrapper from './MuiWrapper';

export const wrapRootElement = ({ element }) => {
  return <MuiWrapper>{element}</MuiWrapper>;
};
